<template>
    <b-tab
            active
    >
        <template #title>
            <feather-icon
                    icon="ImageIcon"
                    size="21"
            />
            <strong>
                Képek
            </strong>
        </template>

        <div>
            <b-overlay
                    :show="loading"
                    spinner-variant="primary"
                    spinner-type="grow"
                    rounded="sm"
            >
                <validation-observer ref="simpleRules">
                    <b-row>
                        <b-col cols="12" class="mb-3">
                            <div class="mb-1">Csoportos képfeltöltéshez húzza rá, vagy kattintás után tallózza be a
                                képeket
                                a lenti
                                beviteli mező segítségével.
                            </div>
                            <b-row>
                                <b-col sm="9">
                                    <validation-provider
                                            #default="{ errors }"
                                            name="fájl"
                                            rules="required"
                                            vid="file"
                                    >
                                        <b-form-file
                                                v-model="images"
                                                placeholder="Válasszon ki vagy húzzon ide a fájlokat"
                                                drop-placeholder="A fájlokat húzza ide..."
                                                browse-text="Tallózás"
                                                accept="image/jpeg,image/png,image/webp"
                                                multiple
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-col>
                                <b-col sm="3">
                                    <b-button
                                            v-if="images.length"
                                            variant="danger"
                                            class="float-left mr-1"
                                            @click.prevent="() => {images = []}"
                                    >
                                        <feather-icon
                                                icon="Trash2Icon"
                                                size="15"
                                        />
                                    </b-button>
                                    <b-button
                                            variant="primary"
                                            type="submit"
                                            :disabled="!images.length"
                                            @click.prevent="submitFiles"
                                    >
                                        Csoportos feltöltés
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                        <!-- képek renderelése -->
                        <b-col cols="12" class="mb-3">
                            <draggable
                                    v-model="tabData"
                                    class="list-group list-group-flush cursor-move d-block w-100"
                                    @change="onDragged"
                            >
                                <transition-group class="row pl-2 pr-2">
                                    <b-col
                                            v-for="(item, index) in tabData"
                                            :key="item.id"
                                            sm="4"
                                    >

                                        <b-card
                                                class="image-card"
                                                :class="{'hidden-image': !item.visible}"
                                                overlay
                                                loading="lazy"
                                                :img-src="item.publicUrl"
                                                :title="item.filename"
                                                img-top
                                        >
                                            <b-card-text>
                                                <div class="mb-0">
                                                    <b-button
                                                            :disabled="item.primary"
                                                            v-b-tooltip.hover title="Beállítás elsődleges képként"
                                                            variant="link"
                                                            size="sm"
                                                            class="ml-1"
                                                            @click.prevent="setPrimaryImage(item.id)"
                                                    >
                                                        <b-icon-star-fill v-if="item.primary" style="color: #fd7e14"
                                                                          size="15"/>
                                                        <b-icon-star v-else style="color: #fd7e14" size="15"/>
                                                    </b-button>

                                                    <b-button
                                                            v-b-tooltip.hover
                                                            :title="(item.pr) ? 'Mégsem PR fotó' : 'Megjelölés PR fotóként'"
                                                            variant="link"
                                                            size="sm"
                                                            class="ml-1"
                                                            @click.prevent="setPr(item.id)"
                                                    >
                                                        <feather-icon
                                                                :style="{'color': (item.pr) ? '#DC3545' : '#198754'}"
                                                                :icon="(item.pr) ? 'CameraOffIcon' : 'CameraIcon'"
                                                                size="15"
                                                        />
                                                    </b-button>

                                                    <b-button
                                                            v-b-tooltip.hover
                                                            :title="(item.visible) ? 'Elrejtés' : 'Láthatóvá tétel'"
                                                            variant="link"
                                                            size="sm"
                                                            class="ml-1"
                                                            @click.prevent="setVisible(item.id)"
                                                    >
                                                        <feather-icon
                                                                :style="{'color': (item.visible) ? '#DC3545' : '#198754'}"
                                                                :icon="(item.visible) ? 'EyeOffIcon' : 'EyeIcon'"
                                                                size="15"
                                                        />
                                                    </b-button>

                                                    <b-button
                                                            v-b-tooltip.hover title="Kép törlése"
                                                            variant="link"
                                                            size="sm"
                                                            class="ml-1"
                                                            @click.prevent="deleteFile(item.id)"
                                                    >
                                                        <feather-icon
                                                                style="color: #DC3545"
                                                                icon="TrashIcon"
                                                                size="15"
                                                        />
                                                    </b-button>
                                                    <b-link
                                                            v-b-tooltip.hover title="Kép letöltése"
                                                            :href="item.downloadUrl"
                                                            target="_blank"
                                                    >
                                                        <b-button
                                                                variant="link"
                                                                size="sm"
                                                                class="ml-1"
                                                        >
                                                            <feather-icon
                                                                    style="color: white"
                                                                    icon="DownloadIcon"
                                                                    size="15"
                                                            />
                                                        </b-button>
                                                    </b-link>
                                                    <b-link
                                                            v-b-tooltip.hover title="Kép nagyítása"
                                                            v-b-modal.record-catch-lightbox-modal
                                                            target="_blank"
                                                            @click="showLightbox(item.downloadUrl)"
                                                    >
                                                        <b-button
                                                                variant="link"
                                                                size="sm"
                                                                class="ml-1"
                                                        >
                                                            <feather-icon
                                                                    style="color: #5594f0"
                                                                    icon="SearchIcon"
                                                                    size="15"
                                                            />
                                                        </b-button>
                                                    </b-link>
                                                    <b-link
                                                            v-if="item.exif_info"
                                                            v-b-tooltip.hover title="EXIF adatok megtekintése"
                                                            v-b-modal.record-catch-exif-modal
                                                            target="_blank"
                                                            @click="showExif(item)"
                                                    >
                                                        <b-button
                                                                variant="link"
                                                                size="sm"
                                                                class="ml-1"
                                                        >
                                                            <feather-icon
                                                                    style="color: #fed700"
                                                                    icon="InfoIcon"
                                                                    size="15"
                                                            />
                                                        </b-button>
                                                    </b-link>
                                                </div>
                                            </b-card-text>
                                        </b-card>
                                    </b-col>
                                </transition-group>
                            </draggable>
                        </b-col>
                    </b-row>
                </validation-observer>
                <lightbox :image-url="lightboxUrl" />
                <exif :exif="exifData" :image-url="exifUrl" />
            </b-overlay>
        </div>
    </b-tab>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
    required,
} from '@validations'
import {
    BTab,
    BBadge,
    BRow,
    BCol,
    BCardGroup,
    BCard,
    BCardText,
    BButton,
    BFormFile,
    BOverlay,
    BModal,
    BForm,
    BFormGroup,
    BLink, BFormInput,
    BIconStar, BIconStarFill, BTooltip,
    VBTooltip
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import gallery from "@/views/pages/_components/_modal/record-catch/gallery.vue";
import Lightbox from "@/views/pages/_components/_modal/record-catch/lightbox.vue";
import Exif from "@/views/pages/_components/_modal/record-catch/exif.vue";

export default {
    components: {
        Exif,
        Lightbox,
        gallery,
        BTooltip,
        BFormInput,
        ValidationProvider,
        ValidationObserver,
        BTab,
        BBadge,
        BRow,
        BCol,
        BCardGroup,
        BCard,
        BCardText,
        BButton,
        BFormFile,
        BOverlay,
        BModal,
        BForm,
        BFormGroup,
        BLink,
        BIconStar, BIconStarFill,
        draggable,
    },
    directives: {
        'b-tooltip': VBTooltip,
        Ripple,
    },
    props: {
        data: [],
        entityId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            loading: false,
            tabData: [],
            dangerCnt: 0,
            images: [],
            required,
            tmp: {
                id: null,
                name: null,
                alt: '',
                image: null,
            },
            lightboxUrl: '',
            exifData: {},
            exifUrl: '',
        }
    },
    watch: {
        data: {
            handler(value) {
                this.tabData = value
                this.initTab()
            }
        }
    },
    computed: {
        hasLoading() {
            return this.loading
        }
    },
    created() {
        this.initTab()
    },
    methods: {
        initTab() {
            this.$store.dispatch('getImagesForRecordCatch', {
                id: this.$route.params.id
            }).then(async response => {
                let tmp = []

                Object.keys(response.data.images).forEach(key => {
                    tmp.push(response.data.images[key])
                })

                this.tabData = tmp

            }).catch(error => {
                if (error.response.status === 422) {
                    this.$refs.simpleRules.setErrors(error.response.data.errors)
                } else {
                    this.$helpers.showErrorToast(error.toString())
                }
            })
        },

        onDragged() {
            this.showLoadBar()
            let newOrder = []

            Object.keys(this.tabData).forEach(key => {
                newOrder.push(this.tabData[key].id)
            })

            this.$store.dispatch('orderImagesForRecordCatch', {
                id: this.entityId,
                order: newOrder
            }).then(() => {
                this.$helpers.showSuccessToast()
            }).catch(error => {
                if (error.response.status === 500) {
                    this.$helpers.showErrorToast(error.response.data.message)
                } else {
                    this.$helpers.showErrorToast(error.toString())
                }
            }).finally(() => {
                this.$emit('refresh-data')
                this.hideLoadBar()
            })
        },

        async submitFiles() {
            if (this.images.length) {
                this.showLoadBar();
                let success = 0;

                for (let key in this.images) {
                    try {
                        let defaultLength = this.tabData.length;

                        const fd = new FormData();
                        fd.append('id', this.$route.params.id);
                        fd.append('file', this.images[key]);
                        fd.append('index', parseInt(defaultLength) + parseInt(key));

                        await this.$store.dispatch('storeImagesForRecordCatch', fd);

                        success++;
                        if (success === this.images.length) {
                            this.images = [];
                            this.$emit('refresh-data');
                            this.$helpers.showSuccessToast();
                        }
                    } catch (error) {
                        if (error.response?.status === 413) {
                            this.$helpers.showErrorToast('A feltölteni kívánt fájl(ok) túl nagy(ok).');
                        } else if (error.response?.status === 400) {
                            this.$helpers.showErrorToast(error.response.data.message);
                        } else if (error.response?.status === 422) {
                            this.$refs.simpleRules.setErrors(error.response.data.errors);
                        } else {
                            this.$helpers.showErrorToast(error.toString());
                        }
                        break;
                    }
                }

                this.$emit('refresh-data');
                this.$helpers.showSuccessToast();

                this.hideLoadBar();
            }
        },

        setPrimaryImage(id) {
            this.showLoadBar()

            this.$store.dispatch('setPrimaryImageForRecordCatch', {
                id: id
            }).then(response => {
                this.$emit('refresh-data')
                this.$helpers.showSuccessToast(response.data.message)
            }).catch(error => {
                this.$helpers.showErrorToast(error.toString())
            }).finally(() => {
                this.hideLoadBar()
            })
        },

        setPr(id) {
            this.showLoadBar()

            this.$store.dispatch('setImagePr', {
                id: id
            }).then(response => {
                this.$emit('refresh-data')
                this.$helpers.showSuccessToast(response.data.message)
            }).catch(error => {
                this.$helpers.showErrorToast(error.toString())
            }).finally(() => {
                this.hideLoadBar()
            })
        },

        setVisible(id) {
            this.showLoadBar()

            this.$store.dispatch('setImageVisible', {
                id: id
            }).then(response => {
                this.$emit('refresh-data')
                this.$helpers.showSuccessToast(response.data.message)
            }).catch(error => {
                this.$helpers.showErrorToast(error.toString())
            }).finally(() => {
                this.hideLoadBar()
            })
        },
        showLightbox(url) {
            this.lightboxUrl = url
        },
        showExif(item) {
            this.exifData = item.exif_info
            this.exifUrl = item.downloadUrl
        },
        deleteFile(fileId, showLoadBar = true) {
            this.$bvModal
                .msgBoxConfirm('Biztosan törölni szeretnéd a képet?', {
                    title: 'Jóváhagyás',
                    size: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Igen',
                    cancelTitle: 'Nem',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if (value) {
                        if (showLoadBar) this.showLoadBar()
                        // axios
                        this.$store.dispatch('deleteImage', fileId).then(() => {
                            this.$emit('refresh-data')
                            this.initTab()
                            this.$helpers.showSuccessToast(`A képet töröltük. (ID: ${fileId})`)
                        }).finally(() => {
                            if (showLoadBar) this.hideLoadBar()
                        })
                    }
                })
        },
        showLoadBar() {
            this.loading = true
        },
        hideLoadBar() {
            this.loading = false
            if (this.$refs.simpleRules) {
                this.$refs.simpleRules.reset();
            }
        },
    }
}
</script>

<style scoped>
.image-card .card-img-overlay {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.image-card .card-img-overlay .card-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 163, 217, 0.8);
    color: #FFFFFF;
    padding: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.image-card .card-img-overlay .card-text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.image-card .card-img-overlay .card-text div:first-child {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.8);
    color: #FFFFFF;
}

.image-card .card-img-overlay .card-text div:nth-child(2) {
    width: 100%;
    background: rgba(0, 0, 0, 1);
}

.image-card .card-img-overlay .card-text {
    display: none;
}

.image-card:hover .card-img-overlay .card-text {
    display: flex;
}

.image-card.hidden-image .card-img-top {
    filter: grayscale(100%);
}
</style>
